import React from "react";
import { FaqResourcePage } from "../components/FaqResourcePage";
import { AML_FAQ_SECTIONS } from "../data/content";

const AmlAuditsFaq = () => (
  <FaqResourcePage
    pageTestId="aml-independent-audits-faq-page"
    kicker="AML Independent Audit FAQs"
    h1Lines={[
      <span key="a">AML independent audits —</span>,
      <span key="b">
        your questions <em className="italic text-[#3E9BDC]">answered.</em>
      </span>,
    ]}
    intro={
      <>
        An AML audit should provide a practical view of how your program is designed, implemented and
        evidenced. These answers address common questions from financial-services firms seeking an
        independent reviewer, preparing for a review or addressing identified issues. American Elm
        Advisors provides independent AML audit support within an agreed scope. We begin by understanding
        the firm's activities, risk profile, systems and timeline before defining the work and requested
        information.
      </>
    }
    primaryCta={{ label: "Discuss your AML audit needs", to: "/contact?topic=AML%20Independent%20Audit" }}
    sections={AML_FAQ_SECTIONS}
    inlineCta={{
      afterSectionId: "preparing-for-an-audit",
      body: "Not sure what scope your firm needs? Tell us about your program and timeline and we'll help you plan the review.",
      buttonLabel: "Discuss your situation",
      to: "/contact?topic=AML%20Independent%20Audit",
      eventName: "faq_inline_aml",
    }}
    closing={{
      heading: "Discuss your AML audit needs.",
      body: "Tell us about your firm, timeline and the review or remediation support you are seeking.",
      primary: { label: "Request a consultation", to: "/contact?topic=AML%20Independent%20Audit" },
      secondary: { label: "Meet our team", to: "/who-we-are", external: false },
    }}
    related={[
      { label: "Compliance consulting", to: "/compliance-consulting" },
      { label: "Trust services consulting", to: "/trust-services-consulting" },
      { label: "Expert witness services", to: "/expert-witness" },
    ]}
  />
);

export default AmlAuditsFaq;
